module.exports = __webpack_public_path__ + "img/newbackground.15a183a2.png";